import { Button, List, Skeleton, Space, Spin } from 'antd';
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { connect } from 'react-redux';
import Job from './Job';
import './index.scss';

const Jobs = ({ task, plugins }) => {
  const { uid } = task;
  const [jobsListLength, setJobsListLength] = useState(5);
  const orchestrator = plugins['weaver-orchestrator'];

  const { data, isLoading } = useQuery({
    queryKey: [`pipelines.tasks.${uid}.jobs`],
    queryFn: () => orchestrator.getJobs({ scheduleUid: uid }),
    refetchInterval: 3000,
  });

  const jobs = data ? JSON.parse(data) : [];
  const sortedJobs = _.orderBy(jobs, ['started'], ['desc']);
  const visibleJobs = _.take(sortedJobs, jobsListLength);

  const handleLoadMore = () => setJobsListLength((prev) => Math.min(prev + 5, jobs.length));

  return (
    <List
      className="jobs-list"
      bordered={false}
      itemLayout="horizontal"
      loadMore={!isLoading && jobs.length > jobsListLength && (
        <div className="jobs-container">
          <Button onClick={handleLoadMore}>Show more</Button>
        </div>
      )}
    >
      {isLoading ? (
        <Space
          size="middle"
          className="loading-container"
        >
          <div>Fetching jobs...</div>
          <Spin />
        </Space>
      ) : jobs.length > 0 ? (
        visibleJobs.map((job) => (
          <List.Item key={job.uid}>
            <Skeleton active title={false} loading={isLoading}>
              <Job orchestrator={orchestrator} job={job} />
            </Skeleton>
          </List.Item>
        ))
      ) : (
        <Space
          size="middle"
          className="no-jobs-container"
        >
          No Jobs
        </Space>
      )}
    </List>
  );
};

const mapStateToProps = ({ explore: { plugins } }) => ({ plugins });
export default connect(mapStateToProps)(Jobs);
